const Dashboard = () => import('@/pages/dashboard/Dashboard.vue');

export default {
  path: '/dashboard',
  name: 'dashboard',
  component: Dashboard,
};
